import { Get } from "./apiUtils";

const getIvoiceList = async (): Promise<any> => {
  const response = await Get(`/api/Customer/invoice`);
  const result = await response.json();
  return result;
};

const getBillingList = async (): Promise<any> => {
  const response = await Get(`/api/Customer/billing`);
  const result = await response.json();
  return result;
};

export const customerApi = {
    getIvoiceList,
    getBillingList,
};

